export default {
  id: null,
  first_name: "",
  last_name: "",
  email: "",
  cell_phoe: "",
  role: "",
  feedback_groups: "",
  token: { digest: "", exp: null },
  submitted: 0,
  sessionId: null,
  use2FA: false,
};
